import React from 'react';

const NotificationsFormWarning = ({ children }) => (
  <div className="notifications-job-warning">
    <div className="notifications-job-warning-icon">
      <svg width={19} height={19} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <path
          fill={'currentColor'}
          d="M256 32c14 0 27 8 35 20l216 368a40 40 0 0 1-35 60H40a40 40 0 0 1-34-60L222 52c7-12 20-20 34-20zm0 128c-13 0-24 11-24 24v112a24 24 0 1 0 48 0V184c0-13-11-24-24-24zm32 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"/>
      </svg>
    </div>
    <div className="notifications-job-warning-text">{children}</div>
  </div>
);

export default NotificationsFormWarning;
